// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "button{border:none}.darkAdmin-omNa4{background:linear-gradient(#fff, #ccc);min-height:100svh;color:#fff}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"darkAdmin": "darkAdmin-omNa4"
};
export default ___CSS_LOADER_EXPORT___;
